import { serialize } from 'utils/utils';
import { CALL_API } from '../middleware/api';

export const TYPES = {
  SUGGEST_DESTINATIONS_REQUEST: 'SUGGEST_DESTINATIONS_REQUEST',
  SUGGEST_DESTINATIONS_SUCCESS: 'SUGGEST_DESTINATIONS_SUCCESS',
  SUGGEST_DESTINATIONS_FAILURE: 'SUGGEST_DESTINATIONS_FAILURE',
  SUGGEST_HOTELS_REQUEST: 'SUGGEST_HOTELS_REQUEST',
  SUGGEST_HOTELS_SUCCESS: 'SUGGEST_HOTELS_SUCCESS',
  SUGGEST_HOTELS_FAILURE: 'SUGGEST_HOTELS_FAILURE',
  CLEAR_SUGGESTIONS: 'CLEAR_SUGGESTIONS',
  SEARCH_INIT: 'SEARCH_INIT',
  SEARCH_SORT: 'SEARCH_SORT',
  SEARCH_DIMENSION_CHANGE: 'SEARCH_DIMENSION_CHANGE',
  SEARCH_RANGE_CHANGE: 'SEARCH_RANGE_CHANGE',
  SEARCH_DIMENSIONS_UPDATE: 'SEARCH_DIMENSIONS_UPDATE',
  SEARCH_RESET_FILTERS: 'SEARCH_RESET_FILTERS',
  SEARCH_CHANGE_FLEXIBILITY: 'SEARCH_CHANGE_FLEXIBILITY',
  SEARCH_DO_SEARCH: 'SEARCH_DO_SEARCH',
};

export const suggestDestinations = (config) => {
  const defaultParams = {
    query: '',
    rows: 5,
  };

  const params = Object.assign(defaultParams, config);

  const endpoint = `/search/suggesterAPI/1.0/suggest?${serialize(params)}`;

  return {
    [CALL_API]: {
      types: [TYPES.SUGGEST_DESTINATIONS_REQUEST, TYPES.SUGGEST_DESTINATIONS_SUCCESS, TYPES.SUGGEST_DESTINATIONS_FAILURE],
      endpoint,
    },
  };
};

export const suggestHotels = (config) => {
  const defaultParams = {
    query: '',
    rows: 10,
  };

  const params = Object.assign(defaultParams, config);

  return {
    [CALL_API]: {
      types: [TYPES.SUGGEST_HOTELS_REQUEST, TYPES.SUGGEST_HOTELS_SUCCESS, TYPES.SUGGEST_HOTELS_FAILURE],
      endpoint: `/search/suggesterAPI/1.0/suggest/hotels?${serialize(params)}`,
    },
  };
};

export const clearSuggestions = () => ({
  type: TYPES.CLEAR_SUGGESTIONS,
});

export const updateDimensions = dimensions => ({
  type: TYPES.SEARCH_DIMENSIONS_UPDATE,
  dimensions,
});

export const optionChanged = (dimension, inputType, dimId, location) => ({
  type: TYPES.SEARCH_DIMENSION_CHANGE,
  dimension,
  inputType,
  dimId,
  location,
});

export const rangeChanged = (field, value) => ({
  type: TYPES.SEARCH_RANGE_CHANGE,
  field,
  value,
});

export const searchFiltersInit = items =>
  Object.assign({ type: TYPES.SEARCH_INIT }, items);

export const sort = (field, value, location) => ({
  type: TYPES.SEARCH_SORT,
  sort: `${field},${value}`,
  location,
});

export const resetFilters = location => ({
  type: TYPES.SEARCH_RESET_FILTERS,
  location,
});

export const changeFlexbility = (deptDateFlexibility, location) => ({
  type: TYPES.SEARCH_CHANGE_FLEXIBILITY,
  location,
  deptDateFlexibility,
});

export const doSearch = toLocation => ({
  type: TYPES.SEARCH_DO_SEARCH,
  toLocation,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/searchActions.js
 **/